<script>
    import MultipleSelector from '@/components/Form/MultipleSelector.vue'

    export default {
        name : 'campaign-selector',
        extends: MultipleSelector,
        methods: {
            buildOptions: function (campaigns) {
                let options = [];
                for (let key in campaigns) {
                    let option = {};
                    option['id'] = campaigns[key]['id'];
                    option['name'] = campaigns[key]['name'];
                    options.push(option);
                }
                return options;
            },
            initCampaigns () {
                fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/Campaigns/list')
                    .then(response => response.json())
                    .then(data => {
                        if (data.result) {
                            this.options = this.buildOptions(data.data);
                        } else {
                            this.emitError();
                        }
                    }).catch(() => {
                        this.emitError();
                    })
            },
            emitError () {
                this.$emit('error', "Se ha producido un error al consultar las campañas.");
            }
        },
        created () {
            this.initCampaigns ();
        }
    }
</script>